import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS } from './-constants';
export const DeviceAssignmentAlertsSearchSchema = z.object({
  ...dataGridSearchFields,
  sortColumn: z.enum(DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS).optional(),
  freeText: z.string().optional(),
  deviceGroupId: z.string().optional(),
  ruleId: z.string().optional()
});
export type DeviceAssignmentAlertsSearch = z.infer<typeof DeviceAssignmentAlertsSearchSchema>;